<template>
  <div class="px-20 py-20 border-box">
    <el-card shadow="never">
      <div class="stat-grid">
        <div class="stat-card clickable" @click="goList('')">
          <div class="lbl">合同总数</div>
          <div class="num">{{ dash.total || 0 }}</div>
          <div class="sub">在管劳动合同 · 点击查看</div>
        </div>
        <div class="stat-card clickable" @click="goList(0)">
          <div class="lbl">生效中</div>
          <div class="num c-ok">{{ dash.active || 0 }}</div>
          <div class="sub">正常履约 · 点击查看</div>
        </div>
        <div class="stat-card clickable" @click="goList(1)">
          <div class="lbl">即将到期</div>
          <div class="num c-warn">{{ dash.expiring || 0 }}</div>
          <div class="sub">30天内到期 · 点击查看</div>
        </div>
        <div class="stat-card clickable" @click="goList(2)">
          <div class="lbl">已逾期</div>
          <div class="num c-bad">{{ dash.expired || 0 }}</div>
          <div class="sub">需及时处理 · 点击查看</div>
        </div>
      </div>
    </el-card>

    <el-row :gutter="16" style="margin-top:16px">
      <el-col :span="12">
        <el-card shadow="never" header="按合同类型分布">
          <el-table :data="typeRows" size="small" border>
            <el-table-column prop="name" label="类型" />
            <el-table-column prop="value" label="数量" width="100" align="center" />
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never" header="按部门分布">
          <el-table :data="deptRows" size="small" border>
            <el-table-column prop="name" label="部门" />
            <el-table-column prop="value" label="数量" width="100" align="center" />
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-card shadow="never" style="margin-top:16px">
      <div slot="header" class="clearfix">
        <span>最近到期合同</span>
        <el-button style="float:right;padding:3px 0" type="text" @click="goList('recent')">查看全部 ›</el-button>
      </div>
      <el-table :data="dash.recentList || []" size="small" border class="recent-table" @row-click="goRow">
        <el-table-column prop="employeeName" label="员工" width="120" />
        <el-table-column prop="contractNo" label="合同编号" width="160" />
        <el-table-column prop="contractTypeName" label="类型" width="120" />
        <el-table-column prop="endDate" label="到期日" width="140" />
        <el-table-column label="状态" width="100">
          <template slot-scope="s">
            <el-tag :type="statusTag(s.row.status)">{{ statusText(s.row.status) }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { dashboardApi } from '@/api/laborContract/index'
export default {
  name: 'LaborDashboard',
  data() {
    return { dash: {} }
  },
  computed: {
    typeRows() {
      const m = this.dash.typeStats || {}
      return Object.keys(m).map(k => ({ name: k, value: m[k] }))
    },
    deptRows() {
      const m = this.dash.deptStats || {}
      return Object.keys(m).map(k => ({ name: k, value: m[k] }))
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      dashboardApi({}).then(res => {
        if (res.code == 200) {
          this.dash = res.data || {}
        }
      })
    },
    // 下钻到合同列表：status 为 0/1/2 时按状态筛选，''/'recent' 查看全部
    goList(status) {
      const query = (status === '' || status === 'recent') ? {} : { status }
      this.$router.push({ path: '/laborContract/contracts', query })
    },
    // 点击最近到期合同某一行，按该合同状态筛选列表
    goRow(row) {
      this.$router.push({ path: '/laborContract/contracts', query: { status: row.status } })
    },
    statusText(s) {
      return ['生效中', '即将到期', '已逾期', '已解除', '已续签', '审批中', '已驳回', '作废'][s] || '-'
    },
    statusTag(s) {
      return ['success', 'warning', 'danger', 'info', 'info', 'warning', 'danger', 'info'][s] || 'info'
    }
  }
}
</script>

<style scoped>
.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
.stat-card {
  background: #f7f9fc;
  border: 1px solid #ebeef5;
  border-radius: 12px;
  padding: 18px;
}
.stat-card .lbl {
  color: #5b6678;
  font-size: 13px;
}
.stat-card .num {
  font-size: 28px;
  font-weight: 800;
  margin-top: 8px;
}
.stat-card .sub {
  font-size: 12px;
  color: #8a94a6;
  margin-top: 4px;
}
.stat-card.clickable {
  cursor: pointer;
  transition: box-shadow .2s, transform .2s;
}
.stat-card.clickable:hover {
  box-shadow: 0 4px 14px rgba(64,158,255,.18);
  transform: translateY(-2px);
}
.recent-table .el-table__row {
  cursor: pointer;
}
.c-ok { color: #1faa6b; }
.c-warn { color: #d98a00; }
.c-bad { color: #e23d3d; }
</style>
